import ga4 from "@/lib/tracking/ga4Core";

export const trackAuctionPinClicked = ({ source, listingType, propertyCategory }) => {
  const eventName = "auction_pin_clicked";
  const eventParams = {
    method: 'clicked_pin',
    source,
    listing_type: listingType,
    property_category: propertyCategory,
    target: 'pin_button',
  };

  ga4.trackUserInteraction(eventName, eventParams);
}

export const trackMapAuctionListingClicked = ({ source, listingType, propertyCategory }) => {
  const eventName = "auction_property_clicked";
  const eventParams = {
    method: 'clicked_property',
    source,
    listing_type: listingType,
    property_category: propertyCategory,
    target: 'property_button',
  };
  ga4.trackUserInteraction(eventName, eventParams);
}

export const trackAuctionListingBrochureClicked = ({ source, listingType, propertyCategory }) => {
  const eventName = "auction_brochure_clicked";
  const eventParams = {
    method: 'clicked_brochure',
    source,
    listing_type: listingType,
    property_category: propertyCategory,
    target: 'brochure_button',
  };

  ga4.trackUserInteraction(eventName, eventParams);
}
